import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import './App.css';
import Home from './components/Home/Home'
import CardDetails from './components/CardDetails/CardDetails'

function App() {
  return (
    <div>
     <Router>
       <Switch>
         <Route exact path="/">
           <Home></Home>
         </Route>
         <Route path="/league/:leagueId">
           <CardDetails></CardDetails>
         </Route>
       </Switch>
     </Router>
    </div>
  );
}

export default App;
